<div class="row">
  <div class="col s12">
    <h4 class="h4 chart-title chart-title--thin margin-none padding-top_half">
      {{ 'groups.dashboard.progressSections' | translate }}
      <gl-tooltip posBottom [text]="tooltipText"></gl-tooltip>
    </h4>
  </div>
</div>
<div class="row">
  <lms-chart
    class="block padding bar-chart"
    [charType]="'bar'"
    [data]="progressSections"
    [labels]="labels"
    [labelLegend]="labelLegend"
    [colors]="colors"
    [legend]="false"
    [options]="options"
  >
  </lms-chart>
</div>
